const commandsMaster = require('./commands/commandsMaster.json');
import firebase from 'firebase/app';
import secondary from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
export default {
    namespaced:true,
    state: {
        commands: [],
        common: [],
        searchResults: [],
        recents: [],
        recentsCap: 6,
        tags: [],
        expandable: [],
        inputSearch: '',
        optionsAll: [],
        optionsUsers: [],
        optionsTeams: [],
        optionsCohorts: [],
        optionsHouses: [],
        timeOptions: [],
        expandOptionsLoading: true,
        recentsLoading: true,
        hasCommon: false,
        hasRecents: false,
        currentlySearching: false,
        jumbledSearching: false,
        expandProps: {
            current: [],
            expandSearch: '',
            memberObject: '',
            expandTime: '',
            memberReady: false,
            timeReady: false,
            navCall: false
        },
        searchHighlights: [],
        commandDatabase: ''
    },
    mutations: {
        setCommands(state:any, result:any) {
            state.commands = result;
        },
        setTags(state:any, result:any) {
            state.tags = result;
        },
        setExpandable(state:any, result:any) {
            state.expandable = result;
        },
        setCommon(state:any, result:any) {
            state.common = result;
        },
        setRecents(state:any, result:any) {
            state.recents = result;
        },
        setSearchResults(state:any, result:any) {
            state.searchResults = result;
        },
        setInputSearch(state:any, value:any) {
            state.inputSearch = value;
        },
        setOptionsAll(state:any, result:any) {
            state.optionsAll = result;
        },
        setOptionsUsers(state:any, result:any) {
            state.optionsUsers = result;
        },
        setOptionsTeams(state:any, result:any) {
            state.optionsTeams = result;
        },
        setOptionsCohorts(state:any, result:any) {
            state.optionsCohorts = result;
        },
        setOptionsHouses(state:any, result:any) {
            state.optionsHouses = result;
        },
        setTimeOptions(state:any, result:any) {
            state.timeOptions = result;
        },
        setExpandOptionsLoading(state:any, result:any) {
            state.expandOptionsLoading = result;
        },
        setRecentsLoading(state:any, result:any) {
            state.recentsLoading = result;
        },
        setHasCommon(state:any, result:any) {
            state.hasCommon = result;
        },
        setHasRecents(state:any, result:any) {
            state.hasRecents = result;
        },
        setCurrentlySearching(state:any, result:any) {
            state.currentlySearching = result;
        },
        setJumbledSearching(state:any, result:any) {
            state.jumbledSearching = result;
        },
        setExpandProps(state:any, result:any) {
            state.expandProps = result;
        },
        clearExpandProps(state:any) {
            const clear = {
                current: [],
                expandSearch: '',
                memberObject: '',
                expandTime: '',
                memberReady: false,
                timeReady: false,
                navCall: false
            };
            state.expandProps = clear;
        },
        setSearchHighlights(state:any, result:any) {
            state.searchHighlights = result;
        },
        pushHighlight(state:any, value:any) {
            state.searchHighlights.push(value);
        },
        reAddHighlight(state:any, payload:any) {
            var searchHighlights = state.searchHighlights;
            searchHighlights.splice(payload.index, 1, payload.highlight);
            state.searchHighlights = searchHighlights;
        },
        sortHighlights(state:any) {
            state.searchHighlights = _.orderBy(state.searchHighlights, ['priority', 'matchCount'], ['asc', 'desc']);
        },
        setCommandDatabase(state:any, result:any) {
            state.commandDatabase = result;
        },
    },
    actions: {
        initCommands({commit, state}:any) {
            var commands = JSON.parse(JSON.stringify(commandsMaster.commands));
            _.forEach(commands, (item, key) => {
                _.assign(item, { command_ID: key })
            });
            commit('setCommands', commands);
        },
        initTags({commit, state}:any) {
            commit('setTags', JSON.parse(JSON.stringify(commandsMaster.tags)));
        },
        initExpandable({commit, state}:any) {
            commit('setExpandable', JSON.parse(JSON.stringify(commandsMaster.expandable)));
        },
        initCommon({commit, state}:any) {
            const common = JSON.parse(JSON.stringify(commandsMaster.common));
            var commonList: any[];
            commonList = [];
            for (var id of common) {
                commonList.push(state.commands[id]);
            }
            if (commonList.length > 0) commit('setHasCommon', true);
            commit('setCommon', commonList);
        },
        async initExpandOptions({commit,dispatch,state,rootState}:any, user:any) {
            commit('setExpandOptionsLoading', true);
            let optionData:Array<any> = [];
            let teamData:Array<any> = [];
            let cohortsData:Array<any> = [];
            let userData:Array<any> = [];
            let membersByTeam:Array<any> = [];
            let users:{ [key: string]: string} = {};
            let house:{ [key: string]: string} = {};
            //optionData.push({value: "all_members", value_options_cohorts: "all_members", label: "All Members", toType: 'all'})

            //retrieve team data from firebase database, push to teamData
            const company = (await firebase.database().ref(`/company/${user.company}`).once('value')).val()
            const team = (await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
            await firebase.database().ref('team').orderByChild("company").equalTo(`${user.company}`).once('value', snapshot => {
                snapshot.forEach((arrData):any => {
                    const u = arrData.val()
                    u.key = arrData.key
                    u.value = "team_" + arrData.key
                    u.value_options_cohorts = "team_" + arrData.key
                    u.label = arrData.val().name
                    u.toType = 'team'
                    teamData.push(u)
                });
                teamData = _.sortBy(teamData, [function(o:any) { return o.label; }])
            });

            //retrieve additional user data from rootState using data in teamData
            for(const arrData in rootState.main.allUser){
                const u = rootState.main.allUser[arrData]
                u.key = arrData
                u.value = "user_" +rootState.main.allUser[arrData].email
                u.value_options_cohorts = "user_" +rootState.main.allUser[arrData].email
                u.label = rootState.main.allUser[arrData].firstname + " " + rootState.main.allUser[arrData].lastname.charAt(0)
                u.toType = 'user'
                if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
                if(u.profilepic_small){
                  u.pic = u.profilepic_small;
                }else if (u.profilepic_crop){
                  u.pic = u.profilepic_crop;
                }else if (u.profilepic){
                  u.pic = u.profilepic;
                }else {
                  u.pic = "";
                }
                if(membersByTeam[u.team] === undefined){
                  membersByTeam[u.team] = new Array()
                }
                users[u.email] = u
                membersByTeam[u.team].push(u)
                userData.push(u)
            }
            await firebase.database().ref(`cohorts/${user.company}`).once('value',async snapshot => {
                const cohorts:Array<any> = [];
                snapshot.forEach((doc):any => {
                    const c = doc.val()
                    c.key = doc.key
                    c.value = doc.val().name
                    c.company_name = company.name
                    c.toType = 'cohort'
                    c.label = c.value
                    if(c.sup === undefined){
                        c.sup = new Array()
                    }

                    //check for duplicate cohorts
                    /*
                    if(c.name){
                        if(checkCohorts[c.name.toLowerCase()]){
                            cohorts_duplicate['status'] = true
                            cohorts_duplicate['count'] += 2
                            c.duplicate = true
                            c.duporder = noDup
                            noDup++
                            const cohortKey = _.findKey(cohorts, ['name', checkCohorts[c.name.toLowerCase()]])
                            if(cohortKey){
                                cohorts[cohortKey].duplicate = true
                                cohorts[cohortKey].duporder = noDup
                                noDup++
                            }
                        }
                        checkCohorts[c.name.toLowerCase()] = c.name
                    }
                    */

                    if(c.users){
                        for (const x in c.users) {
                            if(userData[c.users[x]]){
                                c.sup = _.concat(c.sup, userData[c.users[x]]);
                            }
                        }
                        c.sup = _.sortBy(c.sup, [function(o:any) { return o.firstname; }])
                    }
                    //membersByCohort[c.key] = c.users
                    cohorts.push(c)
                });
                cohortsData = _.sortBy(cohorts, [function(o:any) { return o.duporder; }, function(o:any) { return o.name; }])
                //commit('setCohorts', _cohorts.slice(0, state.size_page))
                }).catch(error => {
                console.log(error)
            });

            //add house data
            let houseData = [
                {
                    key: "-LWPrZbcyHAVHIFUsWLd",
                    label: "House of Corvus",
                    value: "house_-LWPrZbcyHAVHIFUsWLd",
                    value_options_cohorts: "house_-LWPrZbcyHAVHIFUsWLd",
                    toType: 'house',
                },
                {
                    key: "-LWOr-XsbZM2digYl1QL",
                    label: "House of Delphinus",
                    value: "house_-LWOr-XsbZM2digYl1QL",
                    value_options_cohorts: "house_-LWOr-XsbZM2digYl1QL",
                    toType: 'house',
                },
                {
                    key: "-LWPrOElCYViBd6j6qP-",
                    label: "House of Leonos",
                    value: "house_-LWPrOElCYViBd6j6qP-",
                    value_options_cohorts: "house_-LWPrOElCYViBd6j6qP-",
                    toType: 'house',
                },
            ]
            house['-LWPrZbcyHAVHIFUsWLd'] = 'House of Corvus'
            house['-LWOr-XsbZM2digYl1QL'] = 'House of Delphinus'
            house['-LWPrOElCYViBd6j6qP-'] = 'House of Leonos'

            commit('setOptionsUsers',userData)
            //commit('setTeamMaster', team)
            //commit('setUserMaster', users)
            //commit('setHouseMaster', house)
            userData = _.sortBy(userData, [function(o:any) { return o.label; }])
            optionData = _.concat(optionData, houseData, teamData, userData, cohortsData);
            //commit('setMembersByTeam', membersByTeam)
            //commit('setTempOptionTo', optionData)
            commit('setOptionsTeams',teamData)
            commit('setOptionsHouses',houseData)
            commit('setOptionsCohorts', cohortsData)
            commit('setOptionsAll', optionData)
            //commit('setOptionForCohort', optionData)
            commit('setExpandOptionsLoading', false);
        },

        initTimeOptions({commit, state}:any) {
            commit('setTimeOptions', commandsMaster.timeOptions);
        },

        searchCommands({commit, state, dispatch}:any, value: string) {
            commit('setSearchHighlights', []);
            const commands: Array<any> = [];
            const unmatchedCommands: Array<any> = [];
            const matchedWords: Array<any> = [];
            let matches: Array<any> = [];
            commands.push(state.commands);
            if (value.length > 2) {
                if (commands.length > 0) {
                    commit('setCurrentlySearching', true);
                    let direct = '';
                    let index = 0;
                    var wordsArray = _.words(value);
                    wordsArray = _.uniqBy(wordsArray, _.lowerCase);
                    wordsArray = _.remove(wordsArray, (word) => {
                        return (word.length > 1);
                    });
                    if (wordsArray.length != 0) {
                        //prepare a RegExp for matching words with each command title and description text
                        index = 0;
                        for (const word of wordsArray) {
                            if (index == 0) direct = direct.concat(word);
                            else direct = direct.concat("|" + word);
                            index++;
                        }
                        var directRe = new RegExp(direct, 'gi');

                        //*Algorithm 1: Check directRe, number of matches and add priority
                        // console.log(_.upperCase("Algorithm 1: Check directRe, number of matches and add priority"));
                        var directResponse = _.filter(commands[0], (item): any => {
                            var directTitleMatches: Array<any> = Array.from(item.commandTitle.matchAll(directRe));
                            var directDescMatches: Array<any> = Array.from(item.description.matchAll(directRe));

                            directTitleMatches = _.flattenDeep(directTitleMatches);
                            directDescMatches = _.flattenDeep(directDescMatches);

                            if (directTitleMatches.length > 0) {
                                item.priority=1;
                                item.matchCount = directTitleMatches.length;
                                for (var word of directTitleMatches) {
                                    word = _.lowerCase(word);
                                    if(matchedWords.indexOf(word) == -1) matchedWords.push(word);
                                }
                                var highlight = { command: item, fullString: item.commandTitle, targetId: 'title',
                                    priority: 1, matchCount: item.matchCount, offsetIndexes: Array()}
                                dispatch('indexHighlight', {matches: directTitleMatches, highlight: highlight});
                                return true;
                            } else if (directDescMatches.length > 0) {
                                item.priority=2;
                                item.matchCount = directDescMatches.length;
                                for (var word of directDescMatches) {
                                    word = _.lowerCase(word);
                                    if(matchedWords.indexOf(word) == -1) matchedWords.push(word);
                                }
                                var highlight = {command: item, fullString: item.description, targetId: 'desc',
                                    priority: 2, matchCount: item.matchCount, offsetIndexes: Array()}
                                dispatch('indexHighlight', {matches: directDescMatches, highlight: highlight});
                                return true;
                            } else {
                                unmatchedCommands.push(item);
                            }
                        });
                        const unmatchedWords = _.differenceWith(wordsArray, matchedWords);

                        //do algorithm 2 only if there are no directResponses
                        //Future improvements may use unmatchedWords.length > 0, which allows direct and jumbled matches in one search
                        if (directResponse.length == 0) {
                            commit('setJumbledSearching', true);

                            //* Algorithm 2: Check jumbled matches by iterating over string, number of matches and add priority
                            // console.log(_.upperCase("Algorithm 2: Check jumbled matches by iterating over string, number of matches and add priority"));
                            var jumbleResponse = _.filter(unmatchedCommands, (item): any => {
                                var jumbleTitleMatches:Array<any> = [];
                                var jumbleDescMatches:Array<any> = [];

                                var titleWords = _.words(item.commandTitle);
                                var descWords = _.words(item.description);
                                titleWords = _.uniqBy(titleWords, _.lowerCase);
                                titleWords = _.remove(titleWords, (word) => {
                                    return (word.length > 1);
                                });
                                descWords = _.uniqBy(descWords, _.lowerCase);
                                descWords = _.remove(descWords, (word) => {
                                    return (word.length > 1);
                                });

                                for (const word of unmatchedWords) {
                                    var twoLetters = word.slice(0,2);
                                    var twoLettersRe = new RegExp(twoLetters, 'gi');
                                    //only proceed if we know that the string contains at least the first two letters of our word
                                    if (item.commandTitle.match(twoLettersRe)) {
                                        //iterate through words and drop until reaching a word that predicates returns false
                                        //this is our matched word, so push [0] to jumbleTitleMatches
                                        var filterTitleWords = _.dropWhile(titleWords, (item) => {
                                            item = _.lowerCase(item);
                                            var compareArray = item.split("");
                                            let containedLetters = word.split("").filter((char) => {
                                                let index = compareArray.indexOf(char);
                                                if (index != -1) {
                                                    compareArray.splice(index, 1);
                                                    return true;
                                                }
                                            });
                                            //allow some slack for matching up to one letter difference
                                            return (word.length > containedLetters.length + 1);
                                        });
                                        if (filterTitleWords.length > 0) jumbleTitleMatches.push(filterTitleWords[0]);
                                    } else if (item.description.match(twoLettersRe)) {
                                        var filterDescWords = _.dropWhile(descWords, (item) => {
                                            item = _.lowerCase(item);
                                            var compareArray = item.split("");
                                            let containedLetters = word.split("").filter((char) => {
                                                let index = compareArray.indexOf(char);
                                                if (index != -1) {
                                                    compareArray.splice(index, 1);
                                                    return true;
                                                }
                                            });
                                            return (word.length > containedLetters.length + 1);
                                        });
                                        if (filterDescWords.length > 0) jumbleDescMatches.push(filterDescWords[0])
                                    }
                                }

                                if (jumbleTitleMatches.length > 0) {
                                    item.priority=3;
                                    item.matchCount = jumbleTitleMatches.length;
                                    var highlight = { command: item, fullString: item.commandTitle, targetId: 'title',
                                        priority: 3, matchCount: item.matchCount, offsetIndexes: Array()}
                                    dispatch('indexHighlight', {matches: jumbleTitleMatches, highlight: highlight});
                                    return true;
                                } else if (jumbleDescMatches.length > 0) {
                                    item.priority=4;
                                    item.matchCount = jumbleDescMatches.length;
                                    var highlight = { command: item, fullString: item.description, targetId: 'desc',
                                        priority: 4, matchCount: item.matchCount, offsetIndexes: Array()}
                                    dispatch('indexHighlight', {matches: jumbleDescMatches, highlight: highlight});
                                    return true;
                                }
                            });
                            matches = jumbleResponse;
                        } else {
                            commit('setJumbledSearching', false);
                            matches = directResponse;
                        }
                        matches = _.orderBy(matches, ['priority', 'matchCount'], ['asc', 'desc']);
                        commit('sortHighlights');
                        commit('setSearchResults', matches);
                    } else {
                        commit('setSearchResults', []);
                        commit('setSearchHighlights', []);
                    }
                }
            } else if (value.length == 0) {
                commit('setSearchResults', []);
                commit('setCurrentlySearching', false);
                commit('setJumbledSearching', false);
                commit('setSearchHighlights', []);
            }
        },
        indexHighlight({commit, state}:any, payload:any) {
            var matches = payload.matches;
            var highlight = payload.highlight;
            let target = "";
            if (highlight.targetId == 'title') target = "commandTitle";
            else if (highlight.targetId == 'desc') target = "description";

            for (const match of matches) {
                var word = match;
                const re = new RegExp(word, 'gi');
                if (payload.startIndex) {
                    var startIndex = payload.startIndex;
                } else {
                    var startIndex = highlight.command[`${target}`].search(re);
                }
                var endIndex = startIndex + word.length;
                highlight.offsetIndexes.push([startIndex, endIndex]);
            }

            //check if there is are existing highlights for a command. Won't work for current implementation - for future feature.
            // var existingIndex = -1;
            // for (var existing of state.searchHighlights) {
            //     console.log("existing: ", existing);
            //     if (existing.command.command_ID == highlight.command.command_ID) {
            //         existingIndex = state.searchHighlights.indexOf(existing);
            //         break;
            //     }
            // }

            // if (existingIndex != -1) {
            //     highlight.offsetIndexes = _.concat(highlight.offsetIndexes, state.searchHighlights[existingIndex]);
            //     highlight.offsetIndexes = _.uniqWith(highlight.offsetIndexes, _.isEqual);
            //     highlight.offsetIndexes = _.orderBy(highlight.offsetIndexes, [[0]], ['desc']);
            //     commit('reAddHighlight', {highlight: highlight, index: existingIndex});
            // } else {

                //orders offsetIndexes by highest startIndex to lowest startIndex, reversing from right to left
                highlight.offsetIndexes = _.uniqWith(highlight.offsetIndexes, _.isEqual);
                highlight.offsetIndexes = _.orderBy(highlight.offsetIndexes, [[0]], ['desc']);
                commit('pushHighlight', highlight);

            //}
        },

        async setupDatabase({commit, state}:any) {
            commit('setCommandDatabase', firebase.firestore());
        },

        async logDatabase({commit, state}:any) {
            const snapshot = await state.commandDatabase.collection('nav_recents').get();
            snapshot.forEach((doc) => {
            console.log(doc.id, '=>', doc.data());
            });
        },
        async initRecents({commit, state, rootState}:any) {
            commit('setRecentsLoading', true);
            let recents:Array<any> = [];
            let currentuser = rootState.authen.user;

            const recentsRef = state.commandDatabase.collection('nav_recents').doc(`${currentuser.email}`);
            var userNav = await recentsRef.get();
            if (!userNav.exists || !userNav.data().recents) {
                await state.commandDatabase.collection('nav_recents').doc(`${currentuser.email}`).set({ recents: [] });
                userNav = await recentsRef.get();
            }
            const userRecents = userNav.data().recents
            for (var id of userRecents) {
                if (state.commands.hasOwnProperty(id)) recents.unshift(state.commands[id]);
            }
            if (recents.length == 0) commit('setHasRecents', false);
            else commit('setHasRecents', true);

            commit('setRecents', recents);
            commit('setRecentsLoading', false);
        },
        addRecent({commit, state, dispatch}:any, command:any) {
            let recents:Array<any> = state.recents;
            _.remove(recents, (item) => {
                return item == command;
            });
            recents.unshift(command);
            if (recents.length >= state.recentsCap) recents = recents.slice(0,state.recentsCap);
            commit('setHasRecents', true);
            commit('setRecents', recents);
            dispatch('writeRecents');
        },
        removeRecent({commit, state, dispatch}:any, command:any) {
            let recents:Array<any> = state.recents;
            _.remove(recents, (item) => {
                return item == command;
            });
            if (recents.length == 0) commit('setHasRecents', false);
            commit('setRecents', recents);
            dispatch('writeRecents');
        },
        async writeRecents({commit, state, rootState}:any) {
            let recents:Array<any> = [];
            let currentuser = rootState.authen.user;
            for (var item of state.recents) {
                recents.unshift(item.command_ID);
            }
            const data = { recents: recents };
            await state.commandDatabase.collection('nav_recents').doc(`${currentuser.email}`).set(data);
        },
        initializeNav({commit, state, dispatch}:any, user:any) {
            //get list of commands from commandsMaster.json, adds a new field 'command_ID' to each
            dispatch("initCommands");
            //get list of tags from json
            dispatch("initTags");
            //get list of expandable configs from json
            dispatch("initExpandable");
            //get list of common from json, reads each id and pushes the corresponding object into the list
            dispatch("initCommon");

            //gets master list of members, teams and cohorts for selection in expandable commands
            dispatch("initExpandOptions", user);
            //get time options for expandable commands
            dispatch("initTimeOptions");

            dispatch("setupDatabase");
            //reads the data from the database
            //dispatch("logDatabase", user);
            //gets recents (from search results) from database
            dispatch("initRecents", user);
        }

    },
    getters: {
        getCommands(state:any) {
            return state.commands;
        },
        getTags(state:any) {
            return state.tags;
        },
        getExpandable(state:any) {
            return state.expandable;
        },
        getCommon(state:any) {
            return state.common;
        },
        getRecents(state:any) {
            return state.recents;
        },
        getSearchResults(state:any) {
            return state.searchResults;
        },
        getInputSearch(state:any) {
            return state.inputSearch;
        },
        getCurrentlySearching(state:any) {
            return state.currentlySearching;
        },
        getJumbledSearching(state:any) {
            return state.jumbledSearching;
        },
        getOptionsAll(state:any) {
            return state.optionsAll;
        },
        getOptionsUsers(state:any) {
            return state.optionsUsers;
        },
        getOptionsTeams(state:any) {
            return state.optionsTeams;
        },
        getOptionsCohorts(state:any) {
            return state.optionsCohorts;
        },
        getOptionsHouses(state:any) {
            return state.optionsHouses;
        },
        getTimeOptions(state:any) {
            return state.timeOptions;
        },
        getExpandOptionsLoading(state:any) {
            return state.expandOptionsLoading;
        },
        getRecentsLoading(state:any) {
            return state.recentsLoading;
        },
        getHasCommon(state:any) {
            return state.hasCommon;
        },
        getHasRecents(state:any) {
            return state.hasRecents;
        },
        getExpandProps(state:any) {
            return state.expandProps;
        },
        getSearchHighlights(state:any) {
            return state.searchHighlights;
        },
        getCommandDatabase(state:any) {
            return state.commandDatabase;
        }
    }
}